(function (module) {
    "use strict";

    function AddUserCtrl($timeout, $scope, $state, User, Store, addUserSave) {
        this.$onInit = () => {
            this.currentUser = Store.getCurrentUser();
            this.account = Store.getCurrentAccount();
            this.subAccounts = Store.getMultiModelData("subAccounts");
        };

        this.save = () => {
            User.addUserFromAdmin(addUserSave.buildAddUserPayload(this.user, this.account))
                .$promise.then((res) => {
                    $state.go("root.users");
                })
                .catch((error) => {
                    this.api = {
                        message: "",
                    };
                    this.api.message = error.data.error.message;
                });
        };
    }

    module
        .config(($stateProvider) => {
            $stateProvider.state("root.users.add", {
                url: "/new",
                data: {
                    pageTitle: "USERS_ADD.PAGE_TITLE",
                },
                views: {
                    "content@root": {
                        template: "<user-add-component/>",
                    },
                },
            });
        })
        .component("userAddComponent", {
            templateUrl: "/js/users/add-user/add-user.html",
            controller: AddUserCtrl,
        });
})(angular.module("rocket.components"));
